import axios from 'axios'
import store from '@/store'
import NProgress from 'nprogress'

const domainsMap = new Map()

// Devel

domainsMap.set('stq-local.com.br:8581', {
  api: 'http://api.stq-local.com.br',
  auth: 'http://auth.stq-local.com.br:8583/',
  static: 'https://storage.googleapis.com/sotreq-b2c-static/',
})

// Prod
domainsMap.set('sotreqseminovos.com.br', {
  api: 'https://api.sotreqseminovos.com.br',
  static: 'https://storage.googleapis.com/sotreq-b2c-static/',
})
domainsMap.set('www.sotreqseminovos.com.br', {
  api: 'https://api.sotreqseminovos.com.br',
  static: 'https://storage.googleapis.com/sotreq-b2c-static/',
})

// Sandbox
domainsMap.set('sotreq-b2c-store.autoavaliar.com.br', {
  api: 'https://sotreq-b2c-api.autoavaliar.com.br',
  static: 'https://storage.googleapis.com/sotreq-b2c-static/',
})

// Release
domainsMap.set('sb2c-release-store.autoavaliar.com.br', {
  api: 'https://sb2c-release-api.autoavaliar.com.br',
  static: 'https://storage.googleapis.com/sotreq-b2c-static/',
})

const getDomainObj = function () {
  return domainsMap.get(window.location.host)
}

const getStaticUrl = function () {
  let domain = getDomainObj()
  if (domain) return domain.static
}

const getAuthUrl = function () {
  let domain = getDomainObj()
  if (domain) return domain.auth
}

const getApiUrl = function () {
  let domain = getDomainObj()
  if (domain) return domain.api
}

const defaultTransforms = [].concat(axios.defaults.transformResponse || [])

const recoverJsonFromNoise = function (data) {
  if (typeof data !== 'string') return data
  const firstBrace = data.indexOf('{')
  if (firstBrace <= 0) return data
  try {
    return JSON.parse(data.slice(firstBrace))
  } catch (e) {
    return data
  }
}

const axiosDefault = axios.create({
  baseURL: getApiUrl(),
  withCredentials: true,
  transformResponse: defaultTransforms.concat(recoverJsonFromNoise),
  headers: {
    Accept: 'application/json',
    token: localStorage.getItem('token'),
    'Content-Type': 'application/json',
  },
})

const getAxiosInstance = function () {
  axiosDefault.defaults.headers.token = localStorage.getItem('token')
  return axiosDefault
}

const getBody = function (response) {
  const data = response && response.data
  return data && typeof data === 'object' ? data : null
}

const responseHandler = function (response) {
  const data = getBody(response)
  if (!data) return

  if ('toasts' in data) {
    store.dispatch('toaster/addNotifications', data.toasts)
  }

  if ('paginator' in data) {
    store.dispatch('paginator/setPaginatorData', data.paginator)
  }

  if (!data.session?.auth) {
    store.dispatch('session/endSession')
  }
}

const errorsHandler = function (err) {
  store.dispatch('toaster/addNotification', {
    type: 'error',
    message: 'Infelizmente a API não respondeu corretamente!',
    ttl: 3000,
  })

  // console.log(err)

  // if (err.response) {
  //   // The request was made and the server responded with a status code
  //   // that falls out of the range of 2xx

  //   console.log(err.response.data)
  //   console.log(err.response.status)
  //   console.log(err.response.headers)
  // } else if (err.request) {
  //   // The request was made but no response was received
  //   // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
  //   // http.ClientRequest in node.js

  //   console.log(err.request)
  // } else {
  //   // Something happened in setting up the request that triggered an Error

  //   console.log('Error', err.message)
  // }
  // console.log(err.config)
}

const unwrap = function (response) {
  responseHandler(response)
  const data = getBody(response)
  if (!data) {
    errorsHandler(new Error('Resposta sem JSON valido'))
    return undefined
  }
  return data.data
}

const apiPostData = function (url, body, config) {
  NProgress.start()
  return getAxiosInstance()
    .post(url, body, config)
    .then(unwrap)
    .catch((err) => {
      if (axios.isCancel(err)) {
        return undefined
      }
      errorsHandler(err)
    })
    .finally(() => {
      NProgress.done()
    })
}

const apiGetData = function (url) {
  NProgress.start()
  return getAxiosInstance()
    .get(url)
    .then(unwrap)
    .catch((err) => {
      errorsHandler(err)
    })
    .finally(() => {
      NProgress.done()
    })
}

const uploadFile = function (url, file, onUploadProgress) {
  NProgress.start()
  let formData = new FormData()
  formData.append('file', file)
  return getAxiosInstance()
    .post(url, formData, {
      onUploadProgress,
    })
    .then(unwrap)
    .catch((err) => {
      errorsHandler(err)
    })
    .finally(() => {
      NProgress.done()
    })
}

export { apiPostData, apiGetData, uploadFile, getStaticUrl, getAuthUrl }
